import type { EQIAdvisor } from '@/modules/Customer/interface/Advisor';
import { useQuery } from '@tanstack/react-query';
import { captureException } from '@sentry/nextjs';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetCustomerAdvisor = () =>
  useQuery({
    queryKey: ['customer', 'advisor'],
    queryFn: getCustomerAdvisor,
  });

const getCustomerAdvisor = async () => {
  try {
    const { data } = await api.get<{ data: EQIAdvisor }>(
      apiConfig.routes.customer.advisor
    );
    return data.data;
  } catch (error) {
    captureException(
      new Error(
        `Erro ao captar dados do assessor na rota /minha-assessoria` +
          JSON.stringify(error, null, 2)
      )
    );
    throw error;
  }
};
